<template>
    <div
        :class="twMerge(
            'flex flex-col h-full bg-secondary overflow-hidden border-r-primary border-r-1 last:border-r-0',
            highlight ? 'bg-white' : 'bg-secondary'
        )"
    >
        <!-- content -->

        <div class="flex flex-row justify-between">
            <h3 v-if="title" class="paragraph-xs text-secondary px-4 pt-2">
                {{ title }}
            </h3>
            <router-link
                v-if="viewAllLink"
                :to="(viewAllLink.to as RouteLocationRaw)"
                class="paragraph-xs text-cta px-4 pt-2 hover:underline"
                :class="{ 'pointer-events-none opacity-50': viewAllLink.disabled }"
                @click="emit('view-all-click')"
            >
                {{ viewAllLink.label || 'View All' }}
            </router-link>
        </div>

        <div
            ref="scrollContainer"
            :class="twMerge(
                'p-2 w-full flex-1 flex-grow overflow-y-auto',
            )"
            @scroll.stop
        >
            <slot />
        </div>
    </div>
</template>

<script setup lang="ts">
import { nextTick, onMounted, useTemplateRef } from 'vue'
import { twMerge } from 'tailwind-merge'
import type { RouteLocationRaw } from 'vue-router'

type ViewAllLink = {
    to: RouteLocationRaw
    label?: string
    disabled?: boolean
}

type Props = {
    title?: string
    highlight?: boolean
    autoScrollToCurrent?: boolean
    viewAllLink?: ViewAllLink
}

const props = withDefaults(defineProps<Props>(), {
    title: undefined,
    highlight: false,
    autoScrollToCurrent: true,
})

const emit = defineEmits<{
    'view-all-click': []
}>()

const scrollContainer = useTemplateRef('scrollContainer')

onMounted(async () => {
    if (props.autoScrollToCurrent) {
        await nextTick()
        const currentElement = scrollContainer.value?.querySelector('[data-current="true"]')
        if (currentElement) {
            currentElement.scrollIntoView({ block: 'center', behavior: 'instant' })
        }
    }
})
</script>
